/**
 * Authenticated user role.
 * WARNING: Enum key order is by user authority. Do not change.
 */
export enum RoleEnum {
  ADMIN = 'ADMIN',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  ANALYST_USER = 'ANALYST_USER',
  MSSP_MANAGER = 'MSSP_MANAGER',
  MSSP_USER = 'MSSP_USER',
  ORGANIZATION_MANAGER = 'ORGANIZATION_MANAGER',
  ORGANIZATION_USER = 'ORGANIZATION_USER',
}

/**
 * Authenticated user permissions.
 */
export enum PermissionEnum {
  VIEW_ASSET = 'view_asset',
  ADD_ASSET = 'add_asset',
  CHANGE_ASSET = 'change_asset',
  ADD_INCIDENT = 'add_incident',
  CHANGE_INCIDENT = 'change_incident',
  VIEW_INCIDENT = 'view_incident',
  VIEW_INTELLIGENCE = 'view_intelligence',
  START_TAKEDOWN = 'start_takedown',
  CAN_MANAGE_SUPPRESSION = 'can_manage_suppression',
  REVEAL_UNMASK_DATA = 'reveal_unmask_data',
  UNMASK_DATA = 'unmask_data',
}
